export default __webpack_public_path__ + "static/media/4.9fa36bc5.png";